import type { AnyColumnDef } from './Any';

export const getColumnId = (column: AnyColumnDef): string => {
  const id = column.id ?? (column as { accessorKey?: string }).accessorKey;

  if (!id) {
    throw new Error('Column id is required, wrong column definition');
  }

  return id;
};
